<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Invoices</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <p v-if="user">
        Select the options below to view the invoices in the system
      </p>
    </div>
    <div class="row">
      <div class="ui divided items">
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/invoices/unpaid"><i class="massive file alternate icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Unpaid invoices</div>
            <div class="meta">
              <span>Select to view the unpaid invoices</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can view the list of invoices that still have to be paid
            </div>
          </div>
        </div>
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/invoices/paid"><i class="massive file alternate icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Paid invoices</div>
            <div class="meta">
              <span>Select to view the paid invoices</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can view the list of invoices that have been paid together with the VAT owed for the
              period
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Index',
  components: {},
  computed: mapGetters({
    user: 'user',
    usersSchool: 'usersSchool',
  }),
  data() {
    return {};
  },
  methods: {},
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invoices/Index.vue